import { request } from '@umijs/max';
import { stringify } from 'qs';
import { API } from '@/types/user'; 
import { API_BASE_URL } from './common';
/**
 * 如果接口域名不通可用这种方式
 * (`${API_BASE_URL}/api/menu`,
 */




// export async function getCaptchaFromServer(phone: string, options?: { [key: string]: any }) {
//   return request<{
//     data: { captcha: string };
//   }>('${API_BASE_URL}/api/get-captcha', {
//     method: 'POST',
//     data: { phone },
//     ...(options || {}),
//   });
// }

//登录-老接口-加密提交
// export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
//   const formData = new FormData();
//   formData.append('password', body.password);
//   formData.append('username', body.username);
//   formData.append('unitId', body.unitId);

//   return request<API.LoginResult>('${API_BASE_URL}/api/login', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: formData,
//     ...(options || {}),
//   });
// }


// 登录-新接口-明文提交
export async function login(params: API.LoginParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/login`, {
    method: 'POST',
    data: params,
  });
}
export async function logout() {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/logout`, {
    method: 'POST',
  });
}

// 获取验证码
export async function GetSMSCode(params: API.AuthParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/sendSmsCode`, {
    method: 'POST',
    data: params,
  });
}

// 注册
export async function register(params: API.RegisterParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/register`, {
    method: 'POST',
    data: params,
  });
}

// 重置密码
export async function resetPassword(params: API.ResetPasswordParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/resetPassword`, {
    method: 'POST',
    data: params,
  });
}

// 登录-新接口-明文提交
export async function fetchPermission(params:any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/permission/listUserRole?${stringify(params)} `, {
    method: 'GET',
  });
}


// 登录日志
export async function fetchLoginLog(params:any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/login-log/page?${stringify(params)} `, {
    method: 'GET',
  });
}

// 获取用户最新信息
export async function fetchCurUserInfo() {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/getCurUserInfo`, {
    method: 'GET',
  });
}


//**************************** sso 登录  ***********/
// 登录-新接口-明文提交
export async function ssologin(params) {
  return request<API.Result>(`${API_BASE_URL}/api/system/auth/ssologin`, {
    method: 'POST',
    data: params,
  });
}